import { Badge } from 'primereact/badge';
import { MenuItem, MenuItemOptions } from 'primereact/menuitem';
import React from 'react';

export const InvitationItemTemplate = (item: MenuItem, options: MenuItemOptions) => {
  return (
    <a className={options.className} target={item.target} onClick={options.onClick}>
      <span className={options.iconClassName + ' pi ' + item.icon}></span>
      <span className={options.labelClassName}>{item.label}</span>
      <Badge value="2" severity="info" className="ml-2"></Badge>
    </a>
  );
};
